import {get, post, postJson, imagePost, put} from './axios'

const RESOURCE_BASE_PATH = '/Upload-file'

// 获取已上传文件列表
export const getUploadList = p => postJson(`${RESOURCE_BASE_PATH}/list`, p);

// 根据fid删除文件
export const deleteById = p => get(`${RESOURCE_BASE_PATH}/deleteById/${p}`);

// 上传手机号文件
export const uploadMobile = p => imagePost(`${RESOURCE_BASE_PATH}/uploadMobile`, p);

// 获取文件变量标签
export const getLabel = p => get(`${RESOURCE_BASE_PATH}/label`, p);
